























































































































































































import { snakeCase } from 'lodash'
import Vue from 'vue'
import { Component, Emit, Prop, Watch } from 'vue-property-decorator'

import { SelectOption } from "../../../../logic/types";
import { ChannelInfo } from "../../../../models/CheckChannels/CheckChannels";
import BlockMovingControls from '../../../BlockMovingControls/BlockMovingControls.vue'
import EmptyData from '../../../EmptyData/EmptyData.vue'
import { SuccessGetUser } from '../../../Flow/logic/types/type'
import ChannelsInfoHelper from "../../../Flow/new/logic/Helpers/ChannelsInfoHelper";
import { SelectOptionData } from '../../../Pi/types'
import { FullDistribution } from '../../Distribution'
import { ConditionType, UtmSource } from '../types'
import {
  state,
  initConditions,
  removeGroup,
  removeCondition,
  ConditionsState,
  convertFrontendToRaw,
  addGroup,
  addCondition
} from './DistributionConditionsLogic'
import ConditionsListModal from './components/ConditionsListModal.vue'
import DistributionAddItemButton
  from './components/DistributionAddItemButton.vue'
import DistributionActivityCondition from './conditions/DistributionActivityCondition.vue'
import DistributionBoostsCondition from './conditions/DistributionBoostsCondition.vue'
import DistributionLabelsCondition from './conditions/DistributionLabelsCondition.vue'
import DistributionSentCondition from './conditions/DistributionSentCondition.vue'
import DistributionUsersCondition from './conditions/DistributionUsersCondition.vue'
import DistributionUtmCondition from './conditions/DistributionUtmCondition.vue'
import {
  ActivityCondition,
  BoostsCondition,
  LabelsCondition,
  SentCondition,
  UsersCondition,
  UtmCondition
} from './types'

@Component({
  components: {
    DistributionBoostsCondition,
    DistributionAddItemButton,
    EmptyData,
    DistributionUtmCondition,
    DistributionUsersCondition,
    DistributionSentCondition,
    DistributionActivityCondition,
    DistributionLabelsCondition,
    BlockMovingControls,
    ConditionsListModal
  },
  data() {
    return {
      state,
      snakeCase,
      removeGroup,
      addGroup,
      removeCondition,
      ActivityCondition,
      LabelsCondition,
      SentCondition,
      UsersCondition,
      UtmCondition,
      BoostsCondition
    }
  }
})
export default class DistributionConditions extends Vue {
  @Prop() conditions!: FullDistribution['conditions']

  @Prop() utmSources!: Array<UtmSource>

  @Prop() disabled!: boolean

  @Prop() labelsOptions!: Array<SelectOptionData>

  @Prop() getUsersInfo!: (users: Array<string | number>) => Promise<Array<Omit<SuccessGetUser, 'status'>>>

  @Prop() getChannelsInfo!: (targets: Array<string | number>) => Promise<Array<ChannelInfo>>

  @Prop() targets!: Array<SelectOption>

  @Prop({ type: Boolean, required: true, default: false }) isPreCheckLoading!: boolean

  @Prop({ type: Number, required: true, default: 0 }) preCheckCount!: number

  @Emit()
  input(conditions: FullDistribution['conditions']): FullDistribution['conditions'] {
    return conditions
  }

  @Watch('state.frConditions', { deep: true })
  conditionsWatcher(conditions: ConditionsState['frConditions']): void {
    if (conditions) {
      this.input(convertFrontendToRaw())
    }
  }

  isConditionsModalOpen = false

  activeParentGuid: null | string = null

  selectType(type: ConditionType) {
    if (this.activeParentGuid) {
      addCondition(this.activeParentGuid, type)

      this.isConditionsModalOpen = false
      this.activeParentGuid = null
    }
  }

  handleAddCondition(parentGuid: string) {
    this.activeParentGuid = parentGuid
    this.isConditionsModalOpen = true
  }

  handleAddGroup() {
    addGroup()
      .then(guid => {
        this.handleAddCondition(guid)
      })
  }

  isTargetConditionLoading = true

  checkChannels(conditions: FullDistribution['conditions'] | undefined) {
    const targets: Array<number> = []

    if (conditions && conditions.length) {
      conditions.forEach(g => {
        g.forEach(c => {
          if (c instanceof BoostsCondition && c.target_id) {
            targets.push(c.target_id)
          }
        })
      })

      if (targets.length) {
        this.getChannelsInfo(targets)
          .then(res => {
            ChannelsInfoHelper.Channels.unshift(...res)
          })
          .finally(() => {
            this.isTargetConditionLoading = false
          })
      } else {
        this.isTargetConditionLoading = false
      }
    } else {
      this.isTargetConditionLoading = false
    }

  }

  created() {
    this.checkChannels(this.conditions)

    initConditions(this.conditions)
  }
}
